import React from 'react';
import './Home.css';
import { 
  FaFileSignature, FaSyncAlt, FaUsers, FaCalendarTimes,
  FaFileMedical, FaUserPlus, FaChartBar, FaSearch 
} from 'react-icons/fa';

const Home = () => {
  const stats = [
    { title: 'LICENÇAS ATIVAS', value: '247', subtitle: 'Total de licenças em vigor', icon: <FaFileSignature /> },
    { title: 'PROCESSOS EM ANDAMENTO', value: '89', subtitle: 'Aguardando análise técnica', icon: <FaSyncAlt /> },
    { title: 'CONTRIBUINTES ATIVOS', value: '1,234', subtitle: 'Cadastros validados', icon: <FaUsers /> },
    { title: 'VENCIMENTOS PRÓXIMOS', value: '15', subtitle: 'Próximos 30 dias', icon: <FaCalendarTimes /> },
  ];

  const actions = [
    { title: 'Nova Licença', subtitle: 'Iniciar processo de licenciamento ambiental', icon: <FaFileMedical /> },
    { title: 'Cadastrar Contribuinte', subtitle: 'Adicionar novo contribuinte ao sistema', icon: <FaUserPlus /> },
    { title: 'Relatórios', subtitle: 'Gerar relatórios e estatísticas', icon: <FaChartBar /> },
    { title: 'Consultar Processo', subtitle: 'Buscar e acompanhar processos', icon: <FaSearch /> },
  ];

  return (
    <div className="home-container">
      <div className="welcome-banner">
        <h1>Bem-vindo ao GMA</h1>
        <p>Sistema de Gestão em Meio Ambiente - Controle Total e Eficiente</p>
      </div>

      <div className="stats-grid">
        {stats.map((stat, index) => (
          <div key={index} className="stat-card">
            <div className="stat-info">
              <h3>{stat.title}</h3>
              <h2>{stat.value}</h2>
              <p>{stat.subtitle}</p>
            </div>
            <div className="stat-icon-bg">
              {stat.icon}
            </div>
          </div>
        ))}
      </div>

      <div className="actions-section">
        <h2>Ações Rápidas</h2>
        <div className="actions-grid">
          {actions.map((action, index) => (
            <div key={index} className="action-card">
              <div className="action-icon">{action.icon}</div>
              <h3>{action.title}</h3>
              <p>{action.subtitle}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home;
